<div class="card">
  <div class="card-body">
    <div class="row tile-content align-items-stretch">
      <div class="col-12 d-flex flex-column justify-content-between">
        <div>
          <div class="tile-loyalty-icon mb-2">
            <svg>
              <use href="'/assets/images/svg_ico/icons.svg#ic_gift_light'"></use>
            </svg>
          </div>
          <div class="h1 tile-loyalty-title mb-0" i18n="@@loyalty-approve-tile.loyaltyApproveTileTitle">
            Amadeus+Me access approval is needed
          </div>
          <p class="text-gray mb-0" [innerHTML]="loyaltyApproveTileDescriptionString"></p>
          <a routerLink="/amadeus-plus-me/participation">{{ moreDetailsString }}</a>
        </div>
        <div class="mt-4 mt-lg-0 d-grid">
          <div class="form-check form-check-align-top mb-2">
            <input
              class="form-check-input"
              id="agreement-terms-and-conditions-checkbox"
              type="checkbox"
              [formControl]="acceptTerms"
            />
            <label
              class="form-check-label text-gray"
              for="agreement-terms-and-conditions-checkbox"
            >
            {{loyaltyApproveTileAcceptTermsOfUse}}
            <a routerLink="{{termsLink}}" routerLinkActive="active" >
              <span i18n="@@loyalty-approve-tile.loyaltyApproveTileTermsAndConditions">terms and conditions</span>
            </a>
          </label>
          </div>

          <button
            id="loyalty-tile-approve-button"
            type="button"
            class="btn btn-primary"
            (click)="handleApprove()"
            [disabled]="acceptTerms.invalid"
            i18n="@@loyalty-approve-tile.loyaltyApproveTileApproveButton"
          >
            Approve
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
